import 'angular';
import '../../../../../lib/assets/javascripts/devex/util';
import '../../../../../lib/assets/javascripts/devex/urls';
import '../../../angular/services/slug_and_id.service';

const moduleDependencies = [
  'services.SlugAndIdService'
];

angular.module('fundingSearchApp.services.urlHandlingService', moduleDependencies)
  .factory('urlHandlingService', ['SlugAndIdService',
    SlugAndId => {
      const generateReportSlug = report => devex.util.createSlugAndId(report.type, report.id);

      /**
       * Extracts funding type and ID from a slug_and_id variable
       *
       * The slugAndId can come from the Funding Search app itself or
       * from a redirect from old funding project details page. In this case,
       * it can happen that the redirection sends user to
       * `funding/r?report=contract-title-123` instead of
       * `funding/r?report=contract-123`, in other words, the slugAndId can be
       * composed of type, title and id.
       *
       * @param {String} slugAndId: slug to be decomposed
       *
       * @returns {Object} params
       *                   params.type {String}
       *                   params.id {Integer}
       */
      const extractParamsFromSlug = slugAndId => {
        const params = SlugAndId.splitSlugAndId(slugAndId);

        if (!params.slug) {
          return params;
        }

        const dashIndex = params.slug.indexOf('-');

        params.type =
          dashIndex !== -1 ? params.slug.slice(0, dashIndex) : params.slug;

        delete params.slug;
        return params;
      };

      const concatParamsToUrl = (baseUrl, params) => devex.urls.concatParamsToUrl(baseUrl, params);

      return {
        generateReportSlug,
        concatParamsToUrl,
        extractParamsFromSlug,
      };
    }
  ]);
